/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Choose/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import ImageSelect from './ImageSelect/index'
import React from 'react'
import SwitchImages from './SwitchImages/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Choose({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Images/ActiveTab/Images/Content/Content/Content/Comparison/Content/Content/Actions/Choose"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<SwitchImages
  viewPath={`${viewPath}/SwitchImages`}
/>
<div
  data-testid="Choose.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 block={true}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'ImageSelect/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'ImageSelect/Content'))}
 type="secondary"
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Choose image"
/>
)}
</TysiaButton>
</div>
<ImageSelect
  viewPath={`${viewPath}/ImageSelect`}
/>
{children}
</React.Fragment>)
}